module.exports = __webpack_public_path__ + "img/empty_img.2c7f5a69.svg";